/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { type Params } from 'react-router-dom';

import { getTeamName } from '@fai/friendli-suite/features/routes/loaders/apis/client-team';
import { customJson } from '@fai/third-party/react-router-dom';

export const validateTeamId = async ({ params }: { params: Params<'teamId'> }) => {
  const teamName = await getTeamName({
    teamId: params.teamId ?? '',
  });

  if (!teamName) {
    throw customJson({ message: 'invalid team id' }, { status: 401 });
  }

  return null;
};
